import React from 'react';
import './Hero.css';

export default function Hero() {
  return (
    <section id="hero" className="hero">
      {/* LEFT */}
      <div className="hero-left">
        <div className="hero-eyebrow">Intelligence That Protects</div>
        <h1 className="hero-title">
          Secure.<br />Advance.<br /><em>Prevail.</em>
        </h1>
        <p className="hero-sub">
          Grantsman delivers intelligence-led security solutions, open-source analysis,
          and advanced analytics to corporations and institutions navigating complex,
          high-stakes environments.
        </p>
        <div className="hero-actions">
          <a href="#services" className="btn-primary">Explore Services</a>
          <a href="#contact" className="btn-ghost">Get in Touch →</a>
        </div>
      </div>

      {/* RIGHT */}
      <div className="hero-right">
        <div className="hero-grid-overlay" />

        {/* Brand mark centered */}
        <div className="hero-mark-wrap">
          <img src="/mark.PNG" alt="Grantsman mark" className="hero-mark" />
        </div>

        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-num">360°</div>
            <div className="stat-label">Intelligence Coverage</div>
          </div>
          <div className="stat-item">
            <div className="stat-num">6+</div>
            <div className="stat-label">Specializations</div>
          </div>
          <div className="stat-item">
            <div className="stat-num">ZERO</div>
            <div className="stat-label">Compromises. Ever.</div>
          </div>
        </div>

        <div className="hero-corner-tag">Established · Intelligence Division</div>
      </div>
    </section>
  );
}
